import { render, staticRenderFns } from "./sureAAllocation.vue?vue&type=template&id=55b816c2"
import script from "./sureAAllocation.vue?vue&type=script&lang=js"
export * from "./sureAAllocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports